import { Link } from "react-router-dom";
import { T } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/[0.07] bg-[#070A11]" data-testid={T.footer}>
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 sm:px-8 lg:px-14">
        <Link to="/" data-testid="footer-brand-link" className="block">
          <p className="font-serif text-[13vw] font-light leading-[0.9] tracking-tight text-ink/90 sm:text-[9vw] lg:text-[7.5vw]">
            Isabella <span className="serif-italic text-cyanx">MacLeod</span>
          </p>
        </Link>

        <div className="mt-14 grid gap-10 border-t border-white/[0.07] pt-10 md:grid-cols-4">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute2">Explore</p>
            <ul className="mt-4 space-y-2 text-sm text-dim">
              <li><Link className="hover:text-cyanx" to="/books" data-testid="footer-link-books">Books</Link></li>
              <li><Link className="hover:text-cyanx" to="/news" data-testid="footer-link-news">News</Link></li>
              <li><Link className="hover:text-cyanx" to="/about" data-testid="footer-link-about">About</Link></li>
              <li><Link className="hover:text-cyanx" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute2">Elsewhere</p>
            <ul className="mt-4 space-y-2 text-sm text-dim">
              <li>
                <a className="hover:text-cyanx" href="https://substack.com/@nanowoman" target="_blank" rel="noopener noreferrer" data-testid="footer-link-substack">
                  Substack — @nanowoman
                </a>
              </li>
              <li>
                <a className="hover:text-cyanx" href="https://www.booksie.com/users/isabella-macleod-264730" target="_blank" rel="noopener noreferrer" data-testid="footer-link-booksie">
                  Booksie
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute2">Colophon</p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-dim">
              The Miranda trilogy — Metamorphosis, Nano, and Transhuman. Kindle editions are
              sold and delivered by Amazon (KDP Select). Site copy sourced from Isabella's official
              listings and profiles.
            </p>
            <p className="mt-6 font-mono text-[11px] tracking-[0.2em] text-mute2">
              44.6488° N — 63.5761° W · HALIFAX, NOVA SCOTIA
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/[0.07] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mute2">
            © {new Date().getFullYear()} Isabella MacLeod
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mute2">
            R.N. → Patient → Author
          </p>
        </div>
      </div>
    </footer>
  );
}
